module.exports = __webpack_public_path__ + "static/img/h5-1.5b429fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner1/h5-1.png
// module id = Nt9P
// module chunks = 1